<ng-container>
  <div class="blog-comments contaner-fluid">
    <div class="row">
      @if (blogComment() ; as comment) {
      <div class="col-md-2">
        <div class="comment-author-image">
          @if (comment.commentAuthor ;as blogCommentAuthor) {
          <custom-dot-cms-blog-author
            [author]="blogCommentAuthor"
            isBlog="blogAuthor"
            isCommentAuthor="commentAuthor"
          />
          }
        </div>
      </div>
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-12">
            <div class="author-details">
              <span>{{ comment?.commentAuthor?.firstName }}</span>
              <span class="comment-date"
                >@if (comment?.postDate) {
                <i class="icon-clock"></i>
                }
                {{ comment?.postDate | date : 'medium' }}
              </span>
            </div>
            <div class="blog-comments">
              <div class="comments">
                <p [ishServerHtml]="comment?.body"></p>
              </div>
            </div>
            <!--TODO reply comment-->
            @for (replyComment of blogComment().reply; track replyComment) {

            <!-- <ng-container *ngFor="let reply of comment?.reply"> -->
            <div class="reply-comments">
              <div class="reply">
                <custom-dot-cms-blog-comments [blogComment]="replyComment" />
              </div>
            </div>
            }
            <!-- </ng-container> -->
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</ng-container>
